import { ChangeDetectionStrategy, Component, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-general-modal',
  templateUrl: './general-modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class GeneralModalComponent {
  @Output() closeModal = new EventEmitter<void>();
}
